/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ServerTimeDiffToleranceSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('SERVER_TIME_DIFF_TOLERANCE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class ServerTimeDiffToleranceSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ServerTimeDiffToleranceSettingParser.decode(input).map(res => new ServerTimeDiffToleranceSetting(res));
    }
    static unsafeDecode(input) {
        return ServerTimeDiffToleranceSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ServerTimeDiffToleranceSettingParser.encode(data);
    }
    static schema() {
        return ServerTimeDiffToleranceSettingParser.schema();
    }
}
